module.exports = __webpack_public_path__ + "img/eggImageMask.4601ad3f.png";